import React from 'react';
import outlook from '../img/autlook2019.png';
import apiURL from '../hooks/useAPI';

const FormLogin = ({ onChange, onSubmit, carnet, password, cargando, error }) => (
    <form onSubmit={onSubmit}>
        {error ? (
            <div className="alert alert-danger" role="alert">
                <i className="fa fa-exclamation-circle mr-1" aria-hidden="true"></i>
                {error}
            </div>
        ) : null}
        <div className="form-group">
            <label htmlFor="carnet">Usuario</label>
            <input
                type="text"
                className="form-control"
                id="carnet"
                name="carnet"
                autoComplete="username"
                autoFocus
                required
                placeholder="Ej. 20230123"
                onChange={onChange}
                value={carnet} />
        </div>
        <div className="form-group">
            <label htmlFor="password">Contraseña</label>
            <input
                type="password"
                className="form-control"
                id="password"
                name="password"
                autoComplete="current-password"
                required
                placeholder="Tu contraseña"
                onChange={onChange}
                value={password} />
        </div>
        <button
            type="submit"
            className="btn btn-block btn-primary mt-4"
            disabled={cargando}
        >
            {cargando ? (
                <>
                    <span className="spinner-border spinner-border-sm mr-2" role="status" aria-hidden="true"></span>
                    Verificando…
                </>
            ) : 'Iniciar sesión'}
        </button>

        <div className="esen-login-divider" aria-hidden="true">
            <span>o</span>
        </div>

        <a className="btn btn-block esen-btn-microsoft" href={`${apiURL.fetchAPI}auth/microsoft`}>
            <img src={outlook} alt="" />
            Ingresar con correo institucional
        </a>

        <small className="form-text text-muted text-center mt-3">
            No compartas tus credenciales de acceso con nadie.
        </small>
    </form>
)

export default FormLogin
